import React from 'react';
import { Text, Card } from '@mlc/web-ui-toolkit';

const NoMatching: React.FunctionComponent = () => (
	<Card paddingTop={3} paddingBottom={3} margin={3}>
		<Text>No matching records found.</Text>
	</Card>
);

export default NoMatching;
